//import {test_function} from "./../functions/test_function.js";



import { getId } from "../../universal_methods/getId.js";
import { setId } from "../../universal_methods/setId.js";
import { generateId } from "../../universal_methods/generateId.js";
import { isEmpty } from "../../universal_methods/isEmpty.js";
import { getAttributes } from "../../universal_methods/getAttributes.js";
import { toggleDisplay } from "../../universal_methods/toggleDisplay.js";
import { universal_handleErrorFromServer } from "../../universal_methods/universal_handleErrorFromServer.js";
import { combineSmetioAttributes } from "../../universal_methods/combineSmetioAttributes.js";
import { setTxt } from "../../universal_methods/setTxt.js";



import { globalVar } from
  "../../../variables/global_variables.js";

import { errorCodes } from
  "../../../constants/errorCodes.js";



import { SmetioOverlayPreloader } from
  "../../smetioOverlayPreloader/SmetioOverlayPreloader.js";

import { SmetioObjectToInput } from
  "../../smetioObjectToInput/v1.0.0/SmetioObjectToInput.js";


import { SmetioAjax } from
  "../../smetioAjax/SmetioAjax.js";




//import "./styles/_main.scss";
import { SmetioOnOffSwitch } from "../../smetioOnOffSwitch/SmetioOnOffSwitch.js";
import { SmetioCustomCheckbox } from "../../smetioCustomCheckbox/v1.0.0/SmetioCustomCheckbox.js";
import { isValidSmetioBusinessHour } from "@schaniag/private";



export class SmetioBusinessHour {

  constructor(inputObj) {


    this.getId = getId;
    this.setId = setId;
    this.generateId = generateId;
    this.isEmpty = isEmpty;
    this.getAttributes = getAttributes;
    this.toggleDisplay = toggleDisplay;
    this.setTxt = setTxt;

    this.onStartTimeChange = null;
    this.onEndTimeChange = null;

    this.setId();


    

    this.mainObj = inputObj; // SEE SmetioObjectToInput ON WHAT CAN BE CONTAINED IN THE inputObj OBJECT 



    this.status = this.mainObj.attributes.value ? this.mainObj.attributes.value.status || "open" : "open";
    this.startTime = this.mainObj.attributes.value ? this.mainObj.attributes.value.startTime : "00:00";
    this.endTime = this.mainObj.attributes.value ? this.mainObj.attributes.value.endTime : "00:00";
    this.statusText = "";
    this.value = "";
    this.onChange = this.mainObj.events ? this.mainObj.events.onChange : null;



    this.mainClass = "smetio-multi-input-div" + this.id;
    this.mainAttributes = {
      "data-smetio-is-visible": this.isHidden ? false : true,
      class: [

        "smetio-multi-input-div",

        this.mainClass
      ],
    };

    this.inputsDivClass = "smetio-multi-input-inputs-div-" + this.id;
    this.inputsDivAttributes = {
      // disabled: this.status == "closed" ? true : false,
      class: [

        "smetio-multi-input-inputs-div",

        this.inputsDivClass
      ],
    };

    this.startsInputClass = "smetio-multi-input-starts-input-" + this.id;
    this.startsInputAttributes = {
      type: "time",
      value: this.startTime,
      disabled: this.status == "closed" ? true : false,
      title: "txt418",
      class: [
        "smetio-multi-input-starts-input",
        this.startsInputClass
      ],
    };

    this.endsInputClass = "smetio-multi-input-ends-input-" + this.id;
    this.endsInputAttributes = {
      type: "time",
      value: this.endTime,
      disabled: this.status == "closed" ? true : false,
      title: "txt415",
      class: [
        "smetio-multi-input-ends-input",
        this.endsInputClass
      ],
    };

    this.onOffHolderClass = "smetio-multi-input-on-off-btn-holder-" + this.id;
    this.onOffHolderAttributes = {
      class: [
        "smetio-multi-input-on-off-btn-holder",
        this.onOffHolderClass
      ],
    };

    this.onOffLabelClass = "smetio-multi-input-on-off-label-" + this.id;
    this.onOffLabelAttributes = {
      class: [
        "smetio-multi-input-on-off-label",
        this.onOffLabelClass
      ],
    };

    this.readOnlyModeDivClass = "smetio-multi-input-read-only-mode-div-" + this.id;
    this.readOnlyModeDivAttributes = {
      class: [
        "smetio-multi-input-read-only-mode-div",
        this.readOnlyModeDivClass
      ],
    };

  };

  setStatusText(){
    this.statusText = this.status == "open" ? this.changeOnOffLabel("txt416") : this.statusText = this.changeOnOffLabel("txt417"); 
  };

  changeReadOnlyModeDiv(isClosed = false){

    let times = !isClosed ? `${this.getStartTime()} - ${this.getEndTime()}` : "";

    $("."+this.readOnlyModeDivClass).html(`${this.statusText} ${times}`);
  };

  valueHasChanged(whatChaged){

    if(whatChaged == "startTime" && this.onStartTimeChange) this.onStartTimeChange();

    if(whatChaged == "endTime" && this.onEndTimeChange) this.onEndTimeChange();

    this.changeReadOnlyModeDiv();

    this.value = this.getValue();
    this.mainObj.attributes.value = this.value;

    if(this.onChange) this.onChange(this.value);

  };

  isClosed(){
    this.status = "closed";
    this.statusText = this.changeOnOffLabel("txt417");
    $("."+this.inputsDivClass+" input").attr("disabled", true);

    this.changeReadOnlyModeDiv(true);
    this.valueHasChanged();
  };

  isOpen(){
    this.status = "open";
    this.statusText =  this.changeOnOffLabel("txt416");
    $("."+this.inputsDivClass+" input").attr("disabled", false);
    
    this.changeReadOnlyModeDiv();
    this.valueHasChanged();
  };

  isValidInput(){

    return isValidSmetioBusinessHour(this.getValue());

  };

  getSmetioOnOffSwitch() {
    const onOffLabel = this.getOnOffLabel();

    this.smetioOnOffSwitch = new SmetioOnOffSwitch({
      attributes: {
        checked: this.status == "open" ? true : false,
      },
      changeEvents: {
        onChecked: (value) => { 
          this.isOpen();
          if(this.onStatusChanged) this.onStatusChanged();
        },
        onUnChecked: (value) => { 
          this.isClosed();
          if(this.onStatusChanged) this.onStatusChanged();
        },
      }
    });

    return `
      <div class="smetio-multi-input-on-off-btn-and-label-div">

        <div ${this.getAttributes(this.onOffHolderAttributes, false)}> 
          ${this.smetioOnOffSwitch.render()} 
        </div>
        
        ${onOffLabel}
      </div>
    `    
  };

  getStatus(){
    return this.status;
  };

  getValue(){
    return {
      status: this.status,
      startTime: this.getStartTime(),
      endTime: this.getEndTime()
    }
  };

  getStartTime(){
    this.startTime = $("."+this.startsInputClass).val();
    return this.startTime;
  };

  getEndTime(){
    this.endTime = $("."+this.endsInputClass).val();
    return this.endTime;
  };

  getInputs() {

    let text = this.setTxt({
      attributes: this.labelAttributes,
      txt: "txt415",
      type: "html"
    });

    return `
      <div ${this.getAttributes(this.inputsDivAttributes, false)}>

        <div class="smetio-multi-input-starts-input-div" >
          <input ${this.getAttributes(this.startsInputAttributes, false)} >
        </div>

        <div>
          ${text.toLowerCase()}
        </div>

        <div class="smetio-multi-input-ends-input-div">
          <input ${this.getAttributes(this.endsInputAttributes, false)} >
        </div>
        
        <div ${this.getAttributes(this.readOnlyModeDivAttributes, false)}> 
          
        </div>

      </div>
    
    `;
  };

  changeReadonlyStatus({ newStatus = true }) {

    this.isReadonly = newStatus;

    $("." + this.mainClass).find("*").attr("data-smetio-read-only", this.isReadonly);
    // $("." + this.startsInputClass).attr("data-smetio-read-only", this.isReadonly);
    // $("." + this.endsInputClass).attr("data-smetio-read-only", this.isReadonly);
    // $("." + this.onOffHolderClass).attr("data-smetio-read-only", this.isReadonly);    

  };

  changeOnOffLabel(newLabel){

    const text = this.setTxt({
      attributes: this.onOffLabelAttributes,
      txt: newLabel,
      type: "html"
    });

    $("."+this.onOffLabelClass).html(text);

    return text;

  };

  getOnOffLabel() {

    const text = this.setTxt({
      attributes: this.onOffLabelAttributes,
      txt: "txt416",
      type: "html"
    });

    return `
      <div ${this.getAttributes(this.onOffLabelAttributes, false)}>
        ${text}
      </div>
    `
  };

  getContent() {

    // const label = this.getLabel();
    const onOffSwitch = this.getSmetioOnOffSwitch();

    const inputs = this.getInputs();

    return `    
      ${onOffSwitch} ${inputs}
    `;
  };

  render() {

    this.events();

    setTimeout(() => {
      this.setStatusText();
      this.changeReadOnlyModeDiv( this.status == "open" ? false : true);
    }, 200);

    return `
      <div ${this.getAttributes(this.mainAttributes, false)}>
          ${this.getContent()}
      </div>      
    `;

  };

  events() {

    $("body").on("input propertychange change focus", "."+this.startsInputClass, (event)=>{

      // if(this.onStartTimeChange) this.onStartTimeChange();
      this.valueHasChanged("startTime");

    });	

    $("body").on("input propertychange change focus", "."+this.endsInputClass, (event)=>{

      // if(this.onEndTimeChange) this.onEndTimeChange();
      this.valueHasChanged("endTime");
      
    });	

  };

};
